import script from "./NoAvailablePosition.vue?vue&type=script&setup=true&lang=js"
export * from "./NoAvailablePosition.vue?vue&type=script&setup=true&lang=js"

import "./NoAvailablePosition.vue?vue&type=style&index=0&id=4f13d970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f13d970"]])

export default __exports__